/** Form fields from useController are typed `any`; multi-select fields hold string ids. */
export function toStringArray(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
}
